import { render } from "./PasswordPolicyInfo.vue?vue&type=template&id=7d8dbba4"
import script from "./PasswordPolicyInfo.vue?vue&type=script&lang=js"
export * from "./PasswordPolicyInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__